import * as Yup from "yup";
import { FormGroup } from "../../../../components/form/models/models";
import { countries } from "../../../utils/countries";
import { languages } from "../../../utils/languages";

export const childFormLegacy: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "firstName",
      fieldType: "input",
      label: "First Name",
      props: {},
      validation: Yup.string().trim().required("A response is required"), // Basic required validation
    },
    {
      type: "field",
      key: "lastName",
      fieldType: "input",
      label: "Last Name",
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "fieldadv",
      },
      label: "Please ensure that this field is only left blank if the child does not have a surname",
    },
    {
      type: "field",
      key: "dateOfBirth",
      fieldType: "calendar",
      label: "Date of Birth",
      validation: Yup.date().required("A response is required").max(new Date(), "Date may not be a future date"),
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "warning",
      },
      label:
        "If the child is over six years old, please ensure that if a school exemption is required that it has been submitted to the DE regional office. This application cannot be assessed until this has occurred",
    },
    {
      type: "field",
      key: "gender",
      fieldType: "dropdown",
      label: "Gender",
      props: {
        appendTo: "self",
        placeholder: "Select a Gender",
        options: [
          {
            label: "Female",
            value: 1,
          },
          {
            label: "Male",
            value: 2,
          },
          {
            label: "Other",
            value: 3,
          },
          {
            label: "Not Provided",
            value: 4,
          },
        ],
      },
      validation: Yup.string().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "radio",
      key: "placeOfBirth",
      label: "In which country was the child born?",
      validation: Yup.string().required("A response is required"),
      props: {
        options: [
          {
            label: "Australia",
            value: 1,
          },
          {
            label: "Other",
            value: 2,
          },
          {
            label: "Not Provided",
            value: 3,
          },
        ],
      },
    },
    {
      type: "field",
      key: "otherPlaceOfBirth",
      fieldType: "dropdown",
      label: "Please select the country",
      validation: Yup.string().required("A response is required"),
      hideExpression: (formContext, values, model) => model.placeOfBirth != 2,
      props: {
        options: countries,
      },
    },
    {
      type: "field",
      fieldType: "radio",
      key: "isMultiLingual",
      label: "Does the child speak a language other than English at home?",
      validation: Yup.string().required("A response is required"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
          {
            label: "Not Provided",
            value: 2,
          },
        ],
      },
    },
    {
      type: "field",
      key: "otherLanguage",
      fieldType: "dropdown",
      label: "Please select the language",
      hideExpression: (formContext, values, model) => model.isMultiLingual != 1,
      validation: Yup.string().required("A response is required"),
      props: {
        options: languages,
      },
    },
    {
      type: "field",
      key: "isIndigenousAustralian",
      fieldType: "radio",
      label: "Koorie/Aboriginal and or Torres Strait Islander",
      validation: Yup.string().required("An option must be selected"),
      props: {
        options: [
          {
            label: "Yes - Aboriginal",
            value: 1,
          },
          {
            label: "Yes - Torres Strait Islander",
            value: 2,
          },
          {
            label: "Yes - Aboriginal and Torres Strait Islander",
            value: 3,
          },
          {
            label: "No",
            value: 0,
          },
          {
            label: "Not Provided",
            value: 4,
          },
        ],
      },
    },
    {
      type: "field",
      fieldType: "value",
      key: "isInternal",
      calculatedValue: () => true,
    },
  ],
};
